"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageThreeForcedContent;
var _react = _interopRequireDefault(require("react"));
var _Notebook = _interopRequireDefault(require("../svg/Notebook"));
var _utils = require("../../../middleware/utils");
var _PopoverAndOverlay = require("../../Wizard/PopoverAndOverlay");
var _RetirementIncomeGapWizardCalc = require("../RetirementIncomeGapWizardCalc.config");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PageThreeForcedContent(_ref) {
  var {
    currentExpenses,
    futureExpenses
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "eyebrow"
  }, "CALCULATING FUTURE EXPENSES")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-bottom-0 grey-text"
  }, "Current Total Monthly Expenses"), /*#__PURE__*/_react.default.createElement("h2", {
    className: "margin-top-8px grey-text"
  }, (0, _utils.numberToCurrencyString)(currentExpenses)), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-bottom-0"
  }, "Retirement Expenses Adjusted for Inflation", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'futureExpenses',
    text: (0, _htmlReactParser.default)(_RetirementIncomeGapWizardCalc.popoverConfig.futureExpenses)
  })), /*#__PURE__*/_react.default.createElement("h2", {
    className: "margin-top-8px mm-spacing"
  }, (0, _utils.numberToCurrencyString)(futureExpenses)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_Notebook.default, {
    className: "align-top"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sideContent-smallTitle"
  }, "HELPFUL HINT"), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-top-0 mm-spacing--minor"
  }, "Your Future Expenses"))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "rig-sideContent-ul"
  }, /*#__PURE__*/_react.default.createElement("li", null, "If you're planning on having your mortgage paid off by the time you retire, have the satisfaction of eliminating it from your housing expenses. If you will still have a mortgage, note that it typically will not increase based on inflation. You can zero out the inflation rate on your housing expenses later in the calculator."), /*#__PURE__*/_react.default.createElement("li", null, "If you are planning to travel and live it up during retirement, keep your travel and entertainment expenses high.")));
}